// extracted by mini-css-extract-plugin
export default {"root":"CourseTableItem_root__5JypQ","name":"CourseTableItem_name__VYsaL","icon":"CourseTableItem_icon__rCb0K"};